
import { DueDiligenceSourceOfWealth } from '@/store/dueDiligence/types';
import { OpenAccountMetadataOption } from '@/store/openAccount/types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CPDueDiligenceSourceAccordianItem extends Vue {
    @Prop({ required: true })
    public readonly meta!: OpenAccountMetadataOption<number>;

    @Prop({ required: true, type: Array })
    public readonly sourceItems!: DueDiligenceSourceOfWealth[];

    @Prop({ default: false, type: Boolean })
    public readonly viewOnly!: boolean;

    public get model(): DueDiligenceSourceOfWealth | undefined {
        return this.sourceItems.find(item => item.Id === this.meta.value);
    }

    get remarks(): string {
        return this.model?.Remarks ?? '';
    }

    private onRemarksInput(remarks: string) {
        this.$emit('update-remarks', {
            id: this.meta.value,
            remarks: remarks
        });
    }

    private onCheckboxChange(checked: boolean) {
        if (checked) {
            this.$emit('add-item', { 
                Id: this.meta.value, 
                Remarks: '' 
            });
        } else {
            this.$emit('remove-item', this.meta.value);
        }
    }
}
